import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { noop } from 'lodash'
import { selectors as memberSelectors } from 'member-reducer'
import * as memberActions from 'member-actions'
import * as apiActions from 'api-actions'
import { Spinner } from 'lp-components'
import { ProductPrices } from 'types'
import ProductPricesUnavailable from './ProductPricesUnavailable'
import { hasProductPricesLoaded } from 'utils'

const propTypes = {
  blockWhenUnavailable: PropTypes.bool,
  children: PropTypes.node.isRequired,
  clearProductPrices: PropTypes.func.isRequired,
  fetchProductPrices: PropTypes.func.isRequired,
  membershipPrices: ProductPrices,
  trailerCarePrices: ProductPrices,
}

function ProductPricesProvider({
  blockWhenUnavailable = true,
  children,
  clearProductPrices,
  fetchProductPrices,
  membershipPrices = {},
  trailerCarePrices = {},
}) {
  const [isLoadingPrices, setIsLoadingPrices] = useState(true)

  useEffect(() => {
    // A failed or empty response falls through to the pricesLoaded check below.
    fetchProductPrices()
      .catch(noop)
      .finally(() => setIsLoadingPrices(false))

    return () => clearProductPrices()
  }, [fetchProductPrices, clearProductPrices])

  const pricesLoaded = hasProductPricesLoaded({
    membershipPrices,
    trailerCarePrices,
  })

  if (isLoadingPrices) return <Spinner />
  if (pricesLoaded) return children

  // Public flows (Join and Gift) block and ask for a refresh so a member can't
  // continue without correct pricing. The authenticated area renders normally
  // and lets each priced step guard itself.
  if (blockWhenUnavailable) return <ProductPricesUnavailable />

  return children
}

ProductPricesProvider.propTypes = propTypes

function mapStateToProps(state) {
  return {
    membershipPrices: memberSelectors.membershipPrices(state),
    trailerCarePrices: memberSelectors.trailerCarePrices(state),
  }
}

const mapDispatchToProps = {
  clearProductPrices: memberActions.clearProductPrices,
  fetchProductPrices: apiActions.fetchProductPrices,
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductPricesProvider)
